import { CreditnoteApi } from "@/api/CreditnoteApi";
import { CreditnoteProductApi } from "@/api/CreditnoteProductApi";
import { InvoiceApi } from "@/api/InvoiceApi";
import {
    CREDITNOTE_ROOT_NAME,
    PAID_INVOICE_STATUS,
    buildNoteImportDefinition,
} from "./noteImport";

/** Todo lo que el asistente de carga necesita saber de las notas de credito electronicas. */
export const creditnoteImportDefinition = buildNoteImportDefinition({
    documentType: "Creditnote",
    sequenceTypeCode: "03",
    rootName: CREDITNOTE_ROOT_NAME,

    ui: {
        title: "Cargar Notas de Credito XML",
        backUrl: "/user/creditnotes",
        doneActionTitle: "Ir a la lista de notas de credito",
        entityPlural: "notas de credito",
        fileHelpText:
            "Seleccione el XML de una nota de credito electronica, o un archivo ZIP con varias. Las notas se cargan tal como fueron emitidas: conservan su consecutivo y su clave de Hacienda, y no se vuelven a enviar.",
        reviewHelpText:
            "Cada nota tiene que quedar ligada a una factura ya cargada en el sistema. Las que no encuentren su factura no se cargan: cargue primero esa factura y vuelva a intentarlo.",
        confirmHelpText:
            "La carga no modifica existencias ni consume consecutivos, y no altera la factura referenciada.",
        doneHelpText:
            "El listado de notas de credito se alimenta del buscador, que se actualiza unos segundos despues de la carga.",
    },

    loadExistingKeys: () => CreditnoteApi.fetchAllDocumentKeys(),

    // `need_assignment` marca la nota que nacio sobre una factura ya pagada, para que el usuario
    // la asigne despues a otra factura. Es la misma regla que aplica `save-edocument` al emitir.
    extraHeader: (referenced) => ({
        need_assignment: referenced?.status === PAID_INVOICE_STATUS,
    }),

    invalidateCaches: async () => {
        await CreditnoteApi.invalidateAllByTenant();
        CreditnoteApi.clearCache();
        await CreditnoteProductApi.invalidateAllByTenant();
        await InvoiceApi.invalidateAllByTenant();
        InvoiceApi.clearCache();
    },
});

export default creditnoteImportDefinition;
